import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryWeightDetailsReportListing } from './Pages'

export const FactoryWeightDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={FactoryWeightDetailsReportListing} />
    </Fragment>
)